import { createFileRoute } from '@tanstack/react-router';

import { ShopPage } from '@/features/shop/shop-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/shop/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <ShopPage {...params} />;
}
